<template>
	<transition name="error-transition">
		<aside
			v-if="props.hasError"
			class="error-banner"
		>
			<slot>
				<p><i class="fas fa-info-circle" /> {{ props.message }}</p>
			</slot>

			<button
				class="button-close"
				@click="emit('close')"
			>
				<i class="fas fa-times" />
			</button>
		</aside>
	</transition>
</template>
<script lang="ts">
	export interface IErrorBannerProps {
		message?: string;
		hasError: boolean;
	}
</script>
<script setup lang="ts">
	const props = defineProps<IErrorBannerProps>();
	const emit = defineEmits<{ close: [] }>();
</script>
<style>
	aside.error-banner {
		position: fixed;
		top: 0;
		width: 100%;
		padding: 20px;
		background-color: var(--error-color);
		color: var(--background-color);
		z-index: 999;
	}

	aside.error-banner .button-close {
		position: absolute;
		right: 20px;
		top: 50%;
		transform: translateY(-50%);
		border: none;
		background-color: transparent;
		color: var(--background-color);
	}

	aside.error-banner .button-close i {
		font-size: 15pt;
	}

	.error-transition-enter-active,
	.error-transition-leave-active {
		opacity: 1;
		/*max-height: 200px;*/
		transition: all 0.3s linear;
	}

	.error-transition-enter-from,
	.error-transition-leave-to {
		opacity: 0;
		max-height: 0;
		overflow: hidden;
	}
</style>
